import api from './client';
import type { ChartDataResponse, FilterDataResponse, PublicDashboard } from './types';

export const publicDashboardsService = {
  /** Anonymous endpoints accept embed tokens only. */
  getDashboard: (token: string): Promise<PublicDashboard> =>
    api.get(`/public/dashboards/${encodeURIComponent(token)}`, { skipAuth: true }),

  getChartData: (
    token: string,
    chartId: string,
    filters: Record<string, unknown>,
  ): Promise<ChartDataResponse> =>
    api.post(
      `/public/dashboards/${encodeURIComponent(token)}/charts/${encodeURIComponent(chartId)}/data`,
      { filters },
      { skipAuth: true },
    ),

  getFilterData: (
    token: string,
    filterId: string,
    options?: { search?: string; limit?: number; offset?: number },
  ): Promise<FilterDataResponse> => {
    const params = new URLSearchParams();
    if (options?.search) params.set('search', options.search);
    if (options?.limit != null) params.set('limit', String(options.limit));
    if (options?.offset != null) params.set('offset', String(options.offset));
    const query = params.toString();
    return api.get(
      `/public/dashboards/${encodeURIComponent(token)}/filters/${encodeURIComponent(filterId)}/data${query ? `?${query}` : ''}`,
      { skipAuth: true },
    );
  },
};